import { useCompassWebSecurityGetCentralizedOrgIdQuery } from "./get-centralized-org-id.v5.generated";
import { useCompassWebSecurityGetPasswordRulesQuery } from "./get-password-rules.v5.generated";
export var useFetchPasswordRules = function useFetchPasswordRules() {
  var _sessionData$security, _sessionData$security2;
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var organizationId = options.organizationId;
  var skipSessionQuery = Boolean(organizationId);
  var _useCompassWebSecurit = useCompassWebSecurityGetCentralizedOrgIdQuery({
      context: {
        clientName: 'v5'
      },
      skip: skipSessionQuery
    }),
    sessionData = _useCompassWebSecurit.data,
    sessionLoading = _useCompassWebSecurit.loading;
  var centralizedOrganizationId = organizationId !== null && organizationId !== void 0 ? organizationId : sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$security = sessionData.security.current_session) === null || _sessionData$security === void 0 ? void 0 : (_sessionData$security2 = _sessionData$security.centralized_session) === null || _sessionData$security2 === void 0 ? void 0 : _sessionData$security2.centralized_organization_id;
  var _useCompassWebSecurit2 = useCompassWebSecurityGetPasswordRulesQuery({
      variables: {
        // centralizedOrganizationId is guaranteed to be a string here because
        // the query is skipped when it is undefined
        input: {
          centralized_organization_id: centralizedOrganizationId !== null && centralizedOrganizationId !== void 0 ? centralizedOrganizationId : ''
        }
      },
      context: {
        clientName: 'v5'
      },
      skip: !centralizedOrganizationId
    }),
    data = _useCompassWebSecurit2.data,
    loading = _useCompassWebSecurit2.loading,
    error = _useCompassWebSecurit2.error;
  var payload = data === null || data === void 0 ? void 0 : data.security_policies.password_policy;
  return {
    rules: (payload === null || payload === void 0 ? void 0 : payload.__typename) === 'GetPasswordPolicyPayload' ? payload.policy.rules : [],
    loading: sessionLoading || loading,
    error: error
  };
};